import React, { Component, useEffect } from 'react';
import '../App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import logo from '../assets/footer.png';
import twitter from '../assets/x.png';
import teleg from '../assets/tg.png';
import discord from '../assets/discord.png';

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

const tweet = () => {
    window.open("https://x.com/anago_monad_xyz/");
}

const telegL = () => {
    window.open("#");;
}

class Footer extends Component {

    render() {
        return (

            <div class="boxWrap2Footer">

                <div class="footer">

                    <div class="conT" data-aos="zoom-in" data-aos-duration="700">SOCIALS</div>
                    <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Join the ANAGO ARMY</div>

                    <div class="iconsF" data-aos="zoom-in" data-aos-duration="700">
                        <img onClick={tweet} src={twitter} />
                        <img onClick={telegL} src={teleg} />
                        <img src={discord} />
                    </div>
                </div>
                <div class="copyright" data-aos="zoom-in" data-aos-duration="700">Copyright © 2025 ANAGO. All Rights Reserved</div>

                <img class="logoF" src={logo} />


            </div>
        )
    }
}

export default Footer;

